import classNames from 'classnames';
import {Link} from 'react-router-dom';

import DigestMenuIconButton from './_digest_menu_icon_button';
import DigestMenuGroup from './_digest_menu_group';

const DigestMenuOptional = ({
  isCurator,
  multipleDigestsEnabled,
  archiveMode,
  reorderMode,
  hasUnsavedFields,
  editorBusy,
  onNewCustomDigest,
  userSubsPath
}) => {
  if(isCurator && multipleDigestsEnabled) {
    return null;
  }

  return (
    <DigestMenuGroup>
      {!isCurator
        ? <>
          <Link className="digest-menu-button" to={userSubsPath}>
            <DigestMenuIconButton
              icon="settings_outline"
              title="update settings"
              dataTrackingId="update-digest-settings-consumer" />
          </Link>
          {!archiveMode && <Link className="digest-menu-button" to="/digest">
            <DigestMenuIconButton
              icon="send"
              title="digest archives"
              dataTrackingId="digest-archives-consumer" />
          </Link>}
        </>
        : <>
          <DigestMenuIconButton
            icon="add_box"
            title="create custom digest"
            onClick={onNewCustomDigest}
            className={classNames({disabled: reorderMode || editorBusy || hasUnsavedFields})}
            dataTrackingId="create-custom-digest" />
        </>}
    </DigestMenuGroup>
  );
};

DigestMenuOptional.propTypes = {
  isCurator: PropTypes.bool,
  multipleDigestsEnabled: PropTypes.bool,
  archiveMode: PropTypes.bool,
  reorderMode: PropTypes.bool,
  hasUnsavedFields: PropTypes.bool,
  editorBusy: PropTypes.bool,
  onNewCustomDigest: PropTypes.func,
  userSubsPath: PropTypes.string
};

DigestMenuOptional.defaultProps = {
  isCurator: false,
  multipleDigestsEnabled: false,
  archiveMode: false,
  reorderMode: false,
  hasUnsavedFields: false,
  editorBusy: false,
  onNewCustomDigest() {},
  userSubsPath: ''
};

export default DigestMenuOptional;
